import { useEffect, useState } from 'react';
import usePdfDownload from '../../hooks/usePdfDownload';

const getVisualCenter = () => {
  const vv = window.visualViewport;
  return vv
    ? { x: vv.offsetLeft + vv.width / 2, y: vv.offsetTop + vv.height / 2 }
    : { x: window.innerWidth / 2, y: window.innerHeight / 2 };
};

const PdfLoader = () => {
  const { isLoading } = usePdfDownload();
  const [center, setCenter] = useState(getVisualCenter);

  useEffect(() => {
    if (!isLoading) return;

    const update = () => setCenter(getVisualCenter());
    update();

    window.visualViewport?.addEventListener('resize', update);
    window.visualViewport?.addEventListener('scroll', update);
    return () => {
      window.visualViewport?.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('scroll', update);
    };
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className="position-fixed bg-white z-5 top-0 start-0 end-0 bottom-0">
      <div
        className="loader position-absolute translate-middle m-0 "
        style={{
          top: center.y,
          left: center.x
        }}
      >
        <svg viewBox="0 0 80 80">
          <rect x="8" y="8" width="64" height="64"></rect>
        </svg>
      </div>
    </div>
  );
};

export default PdfLoader;
